import { Email as EmailIcon } from "@mui/icons-material";
import { Button, Card, CardActions, CardContent, CardHeader, LinearProgress, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { useProducts } from "../../admin/products/useProducts";
import { useProviderWithId } from "../../admin/providers/useProviderWithId";
import type { CostOrderResponse } from "../costApi";
import { useInvoiceEmailTemplate } from "./useInvoiceEmailTemplate";
import ProviderTermsAndConditions from "../../admin/providers/ProviderTermsAndConditions";

interface Props {
  readonly providerId: string;
  readonly bookingNumber: string;
  readonly order: CostOrderResponse;
}

const ProviderCard: FC<Props> = ({ providerId, bookingNumber, order }) => {
  const { provider, isLoading: isProviderLoading } = useProviderWithId(providerId);
  const { products, isLoading: areProductsLoading } = useProducts();
  const { send } = useInvoiceEmailTemplate({
    providerEmail: provider?.contact.email ?? "",
    bookingNumber,
    productEmails: order.productIds
      .map((id) => products.find((p) => p.id === id)?.contact.email)
      .filter((e): e is string => !!e),
    order: {
      userFriendlyId: order.id.userFriendlyId ?? 0,
      name: order.name,
    },
  });
  return (
    <Card>
      <CardHeader title="Dostawca" />
      <CardContent>
        {(isProviderLoading || areProductsLoading) && <LinearProgress />}
        <Typography variant="h6">{provider?.name}</Typography>
      </CardContent>
      <CardActions>
        <Stack
          direction="row"
          spacing={2}
          sx={{
            justifyContent: "flex-end",
            width: "100%",
          }}
        >
          <ProviderTermsAndConditions providerId={providerId} />
          <Button
            variant="outlined"
            startIcon={<EmailIcon />}
            disabled={!provider?.contact.email}
            onClick={() => send()}
          >
            Email z prośbą o fakturę
          </Button>
        </Stack>
      </CardActions>
    </Card>
  );
};

export default ProviderCard;
